module.exports = __webpack_public_path__ + "3cc87111334e7f33ac581dddb8af2da9.MP3";